import React, { useEffect, useState, useRef } from "react";
import "./UserAccountTransfers.scss";
import { Box, CircularProgress, Typography, Link, FormControlLabel, Checkbox } from "@mui/material";
import RegistrationSelect from "../../UI/Registration/RegistrationSelect";
import RegistrationInput from "../../UI/Registration/RegistrationInput";
import { getErrorMessage2, findScrollableParent } from "../../../util/utilfunctions/utilFunctions";
import Contacts from "./Contacts";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import InternationalTransferHistory from "./InternationalTransfers/InternationalTransferHistory";
import InternationalTransferFooterButtons from "./InternationalTransfers/InternationalTransferFooterButtons";
import PinPad from "../../PinPad/PinPad";
import { useSelector } from "react-redux";
import { getWesternUnionErrorMessage, westernUnionAPI } from "../../../util/API/westernUnion";
import InternationalTransferSummary from "./InternationalTransfers/InternationalTransferSummary";
import WesternUnionReceiverFields from "./InternationalTransfers/WesternUnionReceiverFields";
import InternationalTransferTrack from "./InternationalTransfers/InternationalTransferTrack";
import {ContactDelete} from "../../../util/API/customers";
function WesternUnion({ handleBack }) {

    const [page, setPage] = useState("init");
    const [contacts, setContacts] = useState(null);
    const [history, setHistory] = useState(null);
    const [formValues, setFormValues] = useState({});
    const [formErrors, setFormErrors] = useState({});
    const [alert, setAlert] = useState({});
    const [showPin, setShowPin] = useState(false);
    const [selectedContact, setSelectedContact] = useState(null);
    const [countries, setCountries] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [balance, setBalance] = useState(0);
    const [contactButtonText, setContactButtonText] = useState("Save contact");
    const [fullCountryData, setFullCountryData] = useState([]);
    const [deliveryMethods, setDeliverOptions] = useState([]);
    const [receiverFields, setReceiverFields] = useState({});
    const [visibleFields, setVisibleFields] = useState(new Set());
    const [requiredOverrides, setRequiredOverrides] = useState({});
    const [receiverObj, setReceiverObj] = useState({});
    const [senderObj, setSenderObj] = useState({});
    const [summaryType, setSummaryType] = useState('');
    const [disableContactButton, setDisableContactButton] = useState(false);
    const [orderStatus, setOrderStatus] = useState("");
    const [refundDetails, setRefundDetails] = useState({});
    const [cancelReasons, setCancelReasons] = useState([]);
    const [cancelFormValues, setCancelFormValues] = useState({});
    const [termsChecked, setTermsChecked] = useState(false);
    const [privacyChecked, setPrivacyChecked] = useState(false);
    const [cascadeOptions, setCascadeOptions] = useState({});
    const [prevPage, setPrevPage] = useState('landing');
    const [flow, setFlow] = useState('');

    let isAutoRetry;

    const amountTypes = [
        {key: 'local', value: 'local', label: 'My currency'},
        {key: 'foreign', value: 'foreign', label: 'Receiver currency'}
    ];


    const selectedUser = useSelector((state) => state.usersList.selectedUser);
    const selectedUserID = selectedUser.User.id;
    let agent = sessionStorage.getItem("user");
    agent = JSON.parse(agent);
    agent = agent.payload.body.User;

    useEffect(() => {
        if (page === 'init') {
            setSummaryType('');
            getInitData();
        }
    }, [page]);

    const getInitData = async () => {
        const isOperator = sessionStorage.getItem("isOperator");
        const parentuserid = sessionStorage.getItem("parentuserid");

        let initData = {
            isOperator: isOperator,
            userid: selectedUserID,
            ...selectedUser.User,
            agentName: `${agent.firstName} ${agent.lastName}`,
            parentuserid: parentuserid,
            authUser: agent.id
        }
        setFormValues(initData);

        const response = await westernUnionAPI(initData, "getInitData", { userid: selectedUserID, countryCode: selectedUser.User.telephonenocountrycode });

        let history = response.history;
        if (!Array.isArray(history)) {
            history = [history];
        }

        let contacts = response.contacts.record;
        if (!Array.isArray(contacts)) {
            contacts = [contacts];
        }

        setFullCountryData(response.countries);
        const seenKeys = new Set();
        const countries = [];

        for (const country of response.countries) {
            if (!country.country.code) continue;
            if (!seenKeys.has(country.country.code)) {
                countries.push({
                    key: country.country.code,
                    value: country.country.code,
                    label: country.country.name
                });
                seenKeys.add(country.code);
            }
        }
        setHistory(history);
        setContacts(contacts);
        setCountries(countries);
        setBalance(response.balance);
        createSenderObject(response.kyc, response.countryName, response.kycCountryName, response.piDetails, response.countryCode);
        setContactButtonText('Save Contact');
        setDisableContactButton(false);

        setPage('landing');
    }

    const handlePinConfirm = (event, pin) => {
        const userPin = pin.join('');
        if (summaryType === 'send') {
            sendMoney(userPin);
        } else if (summaryType === 'receive') {
            receiveMoney(userPin);
        } else {
            completeCancel(userPin);
        }
        setShowPin(false);
    }

    const sendMoney = async (pin) => {
        setPage('wait');
        const requestObj = {
            sender: senderObj,
            receiver: receiverObj.receiver,
            payoutDetails: {
                quoteId: formValues.quoteId
            }
        }
        const response = await westernUnionAPI(formValues, "sendMoney", { PIN: pin, orderjsondata: JSON.stringify(requestObj) });

        if (response.Status !== '1') {
            setAlertData(response, true);
            return;
        }
        const transactionID = response.payload.confcode;
        setFormValues((prev) => ({
            ...prev,
            transactionID: transactionID
        }));
        setPage('receipt');
    }
    const handleDeleteContact = async (contact) => {
      try {
        const contactData = contact.Usercontactlistexternal;
        let response = await ContactDelete(
          selectedUserID,
          contactData.id,
          contactData.contactid,
        );
    
        if (response?.data?.header?.callStatus !== "1") {
          setAlert({
            showAlert: true,
            severity: "error",
            message: "Could not delete contact",
            header: "Error",
          });
          return;
        }
    
        setContacts((prev) =>
          prev.filter((c) => c.Usercontactlistexternal.id !== contactData.id),
        );
        setAlert({
          showAlert: true,
          severity: "success",
          message: "Contact deleted successfully",
          header: "Success",
        });
      } catch (error) {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Could not delete contact",
          header: "Error",
        });
      }
    };
    const saveContact = async () => {
        setDisableContactButton(true);
        if (contacts && contacts.length) {
            for (let contact of contacts) {
                let contactInfo = contact.Usercontactlistexternal;
                let savedContactName = contactInfo.lastName; //firstname holds the service name
                savedContactName = savedContactName.replaceAll(/(\s)+/g, ' ');
                let newContactName = formValues.receiverName;
                if (savedContactName.toLowerCase() === newContactName.toLowerCase()) {
                    setContactButtonText('Contact Already Exists');
                    return;
                }
            }
        }

        const response = await westernUnionAPI(formValues, "createExternalContact", {orderjsondata: JSON.stringify(receiverObj)});

        if (response.Status !== "1") {
            setContactButtonText("Could not save contact");
            return;
        }

        setContactButtonText("Contact Saved");
    }

    useEffect(() => {
        if (selectedContact) {
            setPage('contact');
        }
    }, [selectedContact]);

    const getContactInformation = () => {
        if (!selectedContact) return;
        const data = selectedContact.Usercontactlistexternal;
        let otherdata = {};
        try {
            otherdata = JSON.parse(data.other.replaceAll(/&(amp;)*quot;/g, '"'));
        } catch (error) {

        }
        let name = selectedContact.Usercontactlistexternal.lastName;

        const receiverAddressData = otherdata.address;
        const address = receiverAddressData?.line1;
        const city = receiverAddressData?.city;
        const stateProvince = receiverAddressData?.stateProvince;
        const country = otherdata.ctry;
        const currency = otherdata.cur;

        const addressText = `${address ? address + ", " : ''}${city ? city + ", " : ''}${stateProvince ? stateProvince + ", " : ''}${country}`;

        return (
            <Box>
                <Box>Name: {name}</Box>
                <Box>Address: {addressText}</Box>
                <Box>Currency: {currency}</Box>
            </Box>);
    }

    const sendToContact = (item) => {
        setFlow('contact');
        setPrevPage('contact');
        let contactOther = JSON.parse(selectedContact.Usercontactlistexternal.other.replaceAll(/&(amp;)*quot;/g, '"'));
        setFormValues((prev) => ({
            ...prev,
            receivercountry: contactOther.ctry,
            receivercurrency: contactOther.cur,
            payoutmethod: contactOther.payout,
        }));
        setReceiverObj({
            receiver: contactOther.receiver ?? contactOther
        });
        setPage('shortform');
    }

    const resendTransaction = async (item) => {
        setPrevPage('landing');
        setFlow('resend');
        let itemData = JSON.parse(item);
        itemData.agentName = `${agent.firstName} ${agent.lastName}`;
        let orderjsondata = itemData.orderjsondata;
        orderjsondata = JSON.parse(orderjsondata);
        let receiverDetails = orderjsondata.receiver;
        setReceiverObj({ receiver: receiverDetails });
        setFormValues((prev) => ({
            ...prev,
            ...itemData,
        }));
        setPage('shortform');
    }

    const editFormValues = (key, value) => {
        setFormValues((prev) => ({
            ...prev,
            [key]: value
        }))
    }

    const setAlertData = (response, isError, customMessage) => {
        if (customMessage && customMessage.length) {
            setAlert({
                showAlert: true,
                severity: "error",
                message: customMessage,
                header: "Error"
            });
            return;
        }
        if (isError) {
            let errorMessage = '';
            errorMessage += getWesternUnionErrorMessage(response);
            errorMessage += getErrorMessage2(response, isAutoRetry = true);
            setAlert({
                showAlert: true,
                severity: "error",
                message: errorMessage,
                header: "Error"
            });
            setPage('init');
        }
    }

    const getCurrencies = (country) => {
        if (!country) return;
        for (let countryData of fullCountryData) {
            if (country !== countryData.country.code) continue;
            let currencies = countryData.currency;
            if (!Array.isArray(currencies)) {
                currencies = [currencies];
            }
            const mappedCurrencies = [];
            for (let currency of currencies) {
                mappedCurrencies.push({ key: currency.code, value: currency.code, label: currency.name });
            }
            setCurrencies(mappedCurrencies);
        }
    }

    const getDeliveryMethods = async (newValue) => {
        let currency = formValues.receivercurrency;
        let country = formValues.receivercountry;
        if (newValue.length === 3) {
            currency = newValue
        } else {
            country = newValue
        }
        let request = {
            receivercurrency: currency,
            receivercountry: country
        }
        if (!country || !currency) {
            return;
        }
        let response = await westernUnionAPI(request, "getPayoutMethods");

        let methods = response.payload.body.deliveryServices;
        if (!Array.isArray(methods)) {
            methods = [methods];
        }
        let mappedMethods = [];
        for (let method of methods) {
            mappedMethods.push({ key: method.payoutMethodName, value: method.payoutMethodName, label: method.payoutMethodName });
        }
        setDeliverOptions(mappedMethods);
    }

    const getFieldData = async () => {
        if (!validatePage('sendpage1')) {
            return;
        }
        setPrevPage('sendpage1');
        setPage('wait');
        let response = await westernUnionAPI(formValues, "getFieldData");
        let fieldDetails = response.payload.body.fieldsDetails;
        let receiverDetails = fieldDetails.receiver;
        let receiverFields = receiverDetails.fields;

        let senderDetails = fieldDetails.sender.fields;
        const purposeOfTransaction = senderDetails.find((element) => element.name === 'sender.purposeOfTransaction');
        const relationship = senderDetails.find((element) => element.name === 'sender.relationship');

        if (purposeOfTransaction) {
            receiverFields.push(purposeOfTransaction);
        }
        if (relationship) {
            receiverFields.push(relationship);
        }

        setReceiverFields(receiverFields);
        setPage('sendpage2');
    }

    const getQuote = async (previousPage) => {
        setPrevPage(previousPage);
        setPage('wait');
        if (!termsChecked || !privacyChecked) {
            return;
        }
        const quoteObj = {
            receivercountry: formValues.receivercountry,
            receivercurrency: formValues.receivercurrency,
            stateProvince: receiverObj?.receiver?.address?.stateProvince ?? formValues['receiver.address.stateProvince'],
            city: receiverObj?.receiver?.address?.city ?? formValues['receiver.address.city'],
            payoutmethod: formValues.payoutmethod,
            amount: formValues.amount,
            amounttype: formValues.amounttype
        }
        const response = await westernUnionAPI(quoteObj, "getQuote");
        if (response.Status !== '1') {
            setAlertData(response, true);
            return;
        }

        console.log("getQuote_response===========", response);
        setSummaryType('send');
        const responseBody = response.payload.body;
        const fees = responseBody.fees;
        const totalFees = fees.grossFees;
        const serviceFee = fees.baseFees;
        editFormValues('transferFee', serviceFee);
        editFormValues('servicefee', totalFees);
        // const convenienceFee = fees.surchargeFees;
        // editFormValues('convenienceFee', convenienceFee);
        const taxes = responseBody.taxes;
        const totalTaxes = taxes.totalTax;
        // const totalTaxes = taxes.totalTax;
        editFormValues('taxamount', taxes.stateTax);
        editFormValues('convenienceFee', taxes.countryTax);
        const totalAmount = responseBody.grossAmount;
        editFormValues('totalamount', totalAmount);
        const exchangeRate = responseBody.consumerExchangeRate;
        editFormValues('exchangeRate', exchangeRate);
        const consumerSendAmount = responseBody.consumerSendAmount;
        editFormValues('consumerSendAmount', consumerSendAmount);
        const nameType = receiverObj.receiver.name.nameType;
        const expectedPayoutAmt = responseBody.expectedPayoutAmt;
        editFormValues('expectedPayoutAmt', expectedPayoutAmt);
        let receiverName = receiverObj.receiver.name;
        let firstName = '';
        let middleName = '';
        let lastName = '';
        if (nameType === 'I') {
            firstName = receiverName.firstName;
            middleName = receiverName.middleName;
            lastName = receiverName.lastName;
        } else {
            firstName = receiverName.givenName;
            middleName = receiverName.maternalName;
            lastName = receiverName.paternalName;
        }
        receiverName = `${firstName} ${middleName ? middleName + " " : ""}${lastName}`;
        editFormValues('receiverName', receiverName);
        let quoteId = responseBody.quoteId;
        editFormValues('quoteId', quoteId);
        editFormValues('senderFirstName', receiverName.firstName);
        editFormValues('senderLastName', receiverName.lastName);

        setPage('summary');
    }

    const getReceiveTransaction = async () => {
        setPrevPage('receive');
        setPage('wait');
        let receiverData = senderObj;
        receiverData['isQueueAllowed'] = false;
        const requestObj = {
            receiver: receiverData,
            mtcn: formValues.receiveTransId,
        }
        const response = await westernUnionAPI(formValues, "getReceiveTransaction", { receiverjson: JSON.stringify(requestObj) });

        if (response.Status !== '1') {
            setAlertData(response, true);
            return;
        }

        setSummaryType('receive');
        const orderDetails = response.payload.body.orderDetails;
        const senderDetails = orderDetails.sender;
        const payoutDetails = orderDetails.payoutDetails;
        const payoutAmount = payoutDetails.expectedPayoutAmt;
        const receivercountry = payoutDetails.receiverCountry;
        const transactionID = response.payload.body.mtcn;
        const senderName = `${senderDetails.name.firstName} ${senderDetails.name.middleName ? senderDetails.name.middleName + " " : ''}${senderDetails.name.lastName}`
        setFormValues((prev) => ({
            ...prev,
            senderName: senderName,
            transactionID: transactionID,
            amount: payoutAmount,
            receivercountry: receivercountry
        }));
        setPage('summary');
    }

    const receiveMoney = async (pin) => {
        setPage('wait');
        let receiverData = senderObj;
        receiverData['isQueueAllowed'] = false;
        const requestObj = {
            receiver: receiverData,
            mtcn: formValues.receiveTransId,
        }
        const response = await westernUnionAPI(formValues, "receiveMoney", { receiverjson: JSON.stringify(requestObj), PIN: pin });

        if (response.Status !== '1') {
            setAlertData(response, true);
            return;
        }

        setPage('receiptReceive');
    }

    const handleNameTypeChange = (selectedValue) => {
        const nameTypeField = receiverFields?.find?.(
            (field) => field.name === 'receiver.name.nameType'
        );

        if (!nameTypeField) return;

        const newVisibleFields = new Set();
        const newRequiredOverrides = {};

        const matchedCondition = nameTypeField.conditions.find(
            (cond) => cond.valueList.value === selectedValue
        );

        if (matchedCondition) {
            matchedCondition.dependentFieldList.forEach((dep) => {
                newVisibleFields.add(dep.fieldName);
                newRequiredOverrides[dep.fieldName] = dep.dependency === 'M';
            });
        }

        setVisibleFields(newVisibleFields);
        setRequiredOverrides(newRequiredOverrides);
    };

    const setValueByPath = (path, value) => {
        setReceiverObj(prev => {
            const updated = { ...prev };
            const keys = path.split(".");
            let current = updated;

            for (let i = 0; i < keys.length - 1; i++) {
                if (!(keys[i] in current)) {
                    current[keys[i]] = {};
                }
                current = current[keys[i]];
            }

            current[keys[keys.length - 1]] = value;
            return updated;
        });
    };

    const createSenderObject = (kyc, country, kycCoutry, piDetails, countryCode) => {
        let sensitiveData = kyc.sensitiveData.split('|');
        let kycState = kyc.shortcode === 'Passport' ? sensitiveData[10] : sensitiveData[9];
        let kycIssueDate = kyc.shortcode === 'Passport' ? sensitiveData[9] : sensitiveData[8];
        kycIssueDate = kycIssueDate.split("-");
        kycIssueDate = kycIssueDate.reverse();
        kycIssueDate = kycIssueDate.join("");
        let kycExpDate = kyc.shortcode === 'Passport' ? sensitiveData[6] : sensitiveData[5];
        kycExpDate = kycExpDate.split("-");
        kycExpDate = kycExpDate.reverse();
        kycExpDate = kycExpDate.join("");
        let kycNumber = sensitiveData[4];

        let obj = {};
        obj['type'] = "C";
        obj['name'] = {};
        obj.name['nameType'] = 'I';
        obj.name['firstName'] = selectedUser.User.firstName;
        obj.name['middleName'] = '';
        obj.name['lastName'] = selectedUser.User.lastName;

        obj['address'] = {};
        obj.address['country'] = country;
        obj.address['postalCode'] = selectedUser.User.zip;
        obj.address['stateProvince'] = selectedUser.User.stateid;
        obj.address['city'] = selectedUser.User.cityname;
        obj.address['line1'] = selectedUser.User.address1;
        obj.address['line2'] = selectedUser.User.address2;

        obj['contactNumber'] = {};
        obj.contactNumber['phoneNumber'] = selectedUser.User.contactPhoneNo;
        obj.contactNumber['countryCode'] = countryCode;
        obj['mobileNumber'] = obj.contactNumber;

        obj['onHold'] = false;

        let kycType = '';
        switch (obj.notes) {
            case "Passport":
            case "Other national passport":
                kycType = 'A';
                break;
            case "Driver's license":
            case "Driver’s license": 
                kycType = 'C';
                break;
            case "Permanent residence permit":
                kycType = 'D'
                break;
            case "Employee ID":
            case "Registration Letter - Employer":
                kycType = "E";
                break;
            default:
                kycType = "B";
        }

        obj['id1'] = {}
        obj.id1['type'] = kycType;
        obj.id1['number'] = kycNumber;
        obj.id1['issuingAgency'] = kycCoutry;
        obj.id1['issuingAuthority'] = kycState;
        obj.id1['expirationDate'] = kycExpDate;
        obj.id1['issueDate'] = kycIssueDate;

        let dob = selectedUser.User.dateofbirth;
        dob = dob.split("-");
        dob = dob.reverse();
        dob = dob.join("");
        obj['dateOfBirth'] = dob;

        obj['bankDetails'] = {};
        obj.bankDetails['accountNo'] = piDetails.id;
        obj.bankDetails['name'] = "NCS";

        obj['fraudWarningConsent'] = "N";
        setSenderObj(obj);
    }

    const trackTransaction = async(refNumber, data) => {
        setPrevPage('landing');
        setPage('wait');
        let receiverDetails = JSON.parse(data);
        receiverDetails = JSON.parse(receiverDetails.receiverDetails)
        let receiverName = receiverDetails?.receiver?.name ?? receiverDetails.name;
        const firstName = receiverName.firstName ?? receiverName.givenName;
        const middleName = receiverName.middleName ?? receiverName.maternalName;
        const lastName = receiverName.lastName ?? receiverName.paternalName;
        const response = await westernUnionAPI({}, "WUGetTransactionStatus", {mtcn: refNumber, firstname: firstName, middlename: middleName, lastname: lastName, nametype: receiverName.nameType});
        if (response.Status !== "1") {
            setOrderStatus('ERROR');
            setPage("track");
            return;
        }
        const orderStatus = response.payload.body.status;
        console.log("orderStatus----------",orderStatus);
        let dateTime = response.payload.body.dateTime.replaceAll(" ", "");
        dateTime = new Date(dateTime);
        let dayInMs = 24 * 60 * 60 * 1000;
        let currentTime = new Date();
        let cancelOrRefund = "RCAN";
        if (currentTime - dateTime >= dayInMs) {
            cancelOrRefund = "RREF";
        }
        setRefundDetails({
            mtcn: refNumber,
            reasonlist: cancelOrRefund
        });

        if (orderStatus == 'AVAILABLE' || orderStatus == 'Available') {
            setOrderStatus('AVAIL');
        } else if (orderStatus == 'PAID') {
            setOrderStatus('RECVD');
        } else if (orderStatus.match(/refund/gi)) {
            setOrderStatus('REFND');
        } else if (orderStatus == "CANCELLED") {
            setOrderStatus('CANCL');
        } else if (orderStatus == "ON HOLD") {
            setOrderStatus('HOLD');
        } else {
            setOrderStatus('ERROR');
        }
        setPage("track");
    }

    const cancelTransaction = async() => {
        const response = await westernUnionAPI({}, "WUGetReasonList", refundDetails);
        let reasons = response.payload.body.reasonList;

        if (!Array.isArray(reasons)) {
            reasons = [reasons];
        }
        const options = [];
        for (let reason of reasons) {
            options.push({key: reason.code, value: reason.code, label: reason.description, name: reason.description});
        }
        setCancelReasons(options);
        setPage('cancelform');
    }

    const completeCancel = async(pin) => {
        const response = await westernUnionAPI({}, "WUCancelRefundOrder", {...refundDetails, ...cancelFormValues, PIN: pin});
        if (response.Status !== "1") {
            setAlertData(response, true);
            return;
        }
        setShowPin(false);
        setPage('init');
        setAlert({
            showAlert: true,
            severity: "success",
            message: "Transaction cancelled successfully",
            header: ""
        });
    }

    const summaryFields = React.useMemo(() => {
        return (Array.isArray(receiverFields) ? receiverFields : [])
            .filter((field) => {
                const fieldName = field.name;
                const isNameField = fieldName.startsWith('receiver.name.');
                if (isNameField) return false;
                const isVisible =
                    fieldName === 'receiver.name.nameType' ||
                    !isNameField ||
                    visibleFields.has(fieldName);

                const isRequired = requiredOverrides.hasOwnProperty(fieldName)
                    ? requiredOverrides[fieldName]
                    : field.required === 'M';

                const hasValue = formValues[fieldName] != null && formValues[fieldName] !== '';

                return isVisible && isRequired && hasValue;
            })
            .map((field) => {
                const fieldName = field.name;
                const rawValue = formValues[fieldName];
                let displayValue = rawValue;
                if (field.uiFieldType === 'LIST' && field.listValue) {
                    const options = Array.isArray(field.listValue)
                        ? field.listValue
                        : [field.listValue];

                    const matched = options.find(opt => opt.id === rawValue);
                    if (matched) {
                        displayValue = matched.displayValue;
                    }
                }
                if (field.uiFieldType === 'CASCADE_LIST') {
                    const options = cascadeOptions?.[fieldName];
                    const matched = options?.find(opt => opt.value === rawValue);
                    if (matched) {
                        displayValue = matched.label;
                    }
                }

                return {
                    label: field.label.replaceAll(/&(amp;)*#039;/g, "'"),
                    value: displayValue,
                };
            });
    }, [receiverFields, formValues, visibleFields, requiredOverrides]);
    
    const pageOneFields = ['receivercountry', 'receivercurrency', 'payoutmethod', 'amount', 'amounttype'];
    const validatePage = (pageToValidate) => {
        setFormErrors({});
        let isValid = true;
        if (pageToValidate === 'sendpage1') {
            setFlow('sendNewContact');
            for (const field of pageOneFields) {
                if (!formValues[field]) {
                    isValid = false;
                    setFormErrors((prev) => ({
                        ...prev,
                        [field]: true
                    }))
                }
            }
            if (parseFloat(formValues.amount) <= 0) {
                isValid = false;
                setFormErrors((prev) => ({
                    ...prev,
                    amount: true
                }));
            }
        }

        if (pageToValidate === 'sendpage2') {
            let errors = {};
            for (const field of receiverFields) {
                const value = getNestedValue(receiverObj, field.name);
                if ( (field.required === "M" || field.name === "sender.purposeOfTransaction") && (value === undefined || value === "")) {
                    errors[field.name] = `${field.label} is required.`;
                    setFormErrors((prev) => ({
                        ...prev,
                        [field.name]: true
                    }))
                }
            }

            // Second pass: handle conditional required fields (e.g., based on nameType)
            const nameTypeField = receiverFields.find(f => f.name === "receiver.name.nameType");
            const nameTypeValue = getNestedValue(receiverObj, "receiver.name.nameType");

            if (nameTypeField?.conditions?.length && nameTypeValue) {
                const condition = nameTypeField.conditions.find(cond => cond.valueList?.value === nameTypeValue);

                if (condition && condition.dependentFieldList?.length) {
                    for (const dep of condition.dependentFieldList) {
                        const depValue = getNestedValue(receiverObj, dep.fieldName);
                        if (dep.dependency === "M" && (depValue === undefined || depValue === "")) {
                            errors[dep.fieldName] = `${getLabelByName(dep.fieldName, receiverFields)} is required.`;
                        }
                    }
                }
            }
            if (Object.keys(errors).length === 0) {
                setPage('termsAndConditions');
            } else {
                const values = errors && Object.keys(errors).length ? Object.values(errors) : [];
                const errorMessage = values.join("\n");
                setAlertData(null, true, errorMessage);
            }
        }

        if (page === 'termsAndConditions') {
            if (termsChecked && privacyChecked) {
                getQuote('sendpage2');
            } else {
                setAlert({
                    severity: 'error', 
                    showAlert: true,
                    header: '',
                    message: 'Customer must agree to both Terms and Conditions, and the Privacy Statement',
                })
            }
        }

        if (page === 'shortform') {
            const fields = ['amount', 'amounttype'];
            for (const field of fields) {
                if (!formValues[field]) {
                    isValid = false;
                    setFormErrors((prev) => ({
                        ...prev,
                        [field]: true
                    }))
                }
            }
            if (parseFloat(formValues.amount) <= 0) {
                isValid = false;
                setFormErrors((prev) => ({
                    ...prev,
                    amount: true
                }));
            }
            if (isValid) {
                setPage('termsAndConditions');
            }
        }
        
        return isValid;
    }

    function getNestedValue(obj, path) {
        return path.split('.').reduce((acc, part) => acc?.[part], obj);
    }

    function getLabelByName(name, fields) {
        return fields.find(f => f.name === name)?.label || name;
    }

    const containerRef = useRef();
    useEffect(() => {
        if (page === 'termsAndConditions' && containerRef.current) {
            const scrollable = findScrollableParent(containerRef.current);
            if (scrollable) scrollable.scrollTop = 0;
        }

        if (page === 'termsAndConditions') {
            if (flow === 'contact' || flow === 'resend') {
                setPrevPage('shortform');
            } else if (flow === 'sendNewContact') {
                setPrevPage('sendpage2');
            }
        }
    }, [page]);

    return (
        <Box className="container">
            <Box className="pageContainer" sx={{ width: "100%", margin: 'auto' }}>
                <Typography
                    sx={{
                        fontFamily: "'Nunito'",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "21.4825px",
                        color: "#3A3A3A",
                    }} className="text-center">International Transfer - Western Union</Typography>
                {page === 'landing' ?
                    <Box>
                        <Box className="contactContainer">
                            <Box className="d-flex justify-content-between">
                                <Box className="lh-lg fw-bold">Contacts</Box>
                            </Box>
                            <Contacts
                                contacts={contacts}
                                service={"WesternUnion"}
                                setSelectedContact={setSelectedContact}
                                onDeleteContact={handleDeleteContact} />
                        </Box>
                        <Box className="historyContainer mt-3">
                            <Box className="fw-bold">Recent History</Box>
                            <InternationalTransferHistory
                                history={history}
                                service={"WESTERNUNION"}
                                trackTransaction={(refNumber, data) => trackTransaction(refNumber, data)}
                                handleResend={(item) => resendTransaction(item)}
                            />
                        </Box>
                        <InternationalTransferFooterButtons
                            handleButtonOne={handleBack}
                            handleButtonTwo={() => setPage('receive')}
                            handleMiddleButton={() => setPage('sendpage1')}
                            buttonOneText="Return"
                            buttonTwoText="Receive Money"
                            middleButtonText="Send Money To New Contact"
                            showMiddleButton={true}
                            showButtonTwo={true}
                        />

                    </Box> : ''}
                {page === 'sendpage1' ?

                    <Box
                        sx={{
                            maxHeight: "600px",
                            marginTop: "10px"
                        }}>
                        <RegistrationSelect
                            label="Receiving Country"
                            type="text"
                            options={countries}
                            onChange={(e) => { editFormValues('receivercountry', e.target.value); getCurrencies(e.target.value); getDeliveryMethods(e.target.value); }}
                            value={formValues.receivercountry}
                            required={true}
                            hasError={formErrors.receivercountry} />
                        <RegistrationSelect
                            label="Receiving Currency"
                            type="text"
                            options={currencies ?? []}
                            onChange={(e) => { editFormValues('receivercurrency', e.target.value); getDeliveryMethods(e.target.value); }}
                            value={formValues.receivercurrency}
                            required={true}
                            hasError={formErrors.receivercurrency} />
                        <RegistrationSelect
                            label="Delivery Method"
                            options={deliveryMethods ?? []}
                            required={true}
                            onChange={(e) => editFormValues('payoutmethod', e.target.value)}
                            value={formValues.payoutmethod}
                            hasError={formErrors.payoutmethod} />
                        <RegistrationInput
                            label="Amount"
                            required={true}
                            onChange={(e) => editFormValues('amount', e.target.value)}
                            value={formValues.amount}
                            hasError={formErrors.amount} />
                        <RegistrationSelect
                            label="Amount Type"
                            options={amountTypes ?? []}
                            required={true}
                            onChange={(e) => editFormValues('amounttype', e.target.value)}
                            value={formValues.amounttype}
                            hasError={formErrors.amounttype} />
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('landing')}
                            handleButtonTwo={getFieldData}
                            buttonOneText="Back"
                            buttonTwoText="Next"
                            showMiddleButton={false}
                            showButtonTwo={true}
                        />
                    </Box>

                    : ''}
                {
                    page === 'summary' ?
                        <Box
                            sx={{
                                maxHeight: "600px",
                                marginTop: "10px"
                            }}>
                            <InternationalTransferSummary
                                transferDetails={formValues}
                                type={summaryType}
                                handleReturn={() => setPage(prevPage)}
                                service="WesternUnion"
                                user={selectedUser}
                                handleContinue={() => setShowPin(true)}
                                handleSaveContact={saveContact}
                                contactButtonText={contactButtonText}
                                disableSaveContact={disableContactButton}
                                additionalDetails={summaryFields}
                            />
                        </Box>
                        : ""
                }

                {
                    
                    page === 'sendpage2' ?
                        <Box
                            sx={{
                                maxHeight: "600px",
                                marginTop: "10px"
                            }}>

                            <WesternUnionReceiverFields
                                receiverFields={receiverFields}
                                formValues={formValues}
                                formErrors={formErrors}
                                editFormValues={editFormValues}
                                visibleFields={visibleFields}
                                requiredOverrides={requiredOverrides}
                                handleNameTypeChange={handleNameTypeChange}
                                setValueByPath={setValueByPath}
                                liftCascadeOptions={setCascadeOptions}
                            />
                            <InternationalTransferFooterButtons
                                handleButtonOne={() => setPage('sendpage1')}
                                handleButtonTwo={() => validatePage('sendpage2')}
                                buttonOneText="Back"
                                buttonTwoText="Next"
                                showMiddleButton={false}
                                showButtonTwo={true}
                            />
                        </Box>
                        : ""
                }

                {
                    page === 'receive' ?
                        <Box
                            sx={{
                                maxHeight: "600px",
                                marginTop: "10px"
                            }}>

                            <RegistrationInput
                                label="MTCN"
                                required={true}
                                onChange={(e) => editFormValues('receiveTransId', e.target.value)}
                                value={formValues.receiveTransId}
                                hasError={formErrors.receiveTransId} />
                            <InternationalTransferFooterButtons
                                handleButtonOne={() => setPage(prevPage)}
                                handleButtonTwo={() => getReceiveTransaction()}
                                buttonOneText="Back"
                                buttonTwoText="Next"
                                showMiddleButton={false}
                                showButtonTwo={true}
                            />
                        </Box>
                        : ""
                }

                {
                    page === 'receipt' ?
                        <Box
                            sx={{
                                maxHeight: "600px",
                                marginTop: "10px"
                            }}>

                            <InternationalTransferSummary
                                type="send"
                                transferDetails={formValues}
                                handleReturn={() => setPage("init")}
                                user={selectedUser}
                                handleContinue={() => setPage("init")}
                                isReceipt={true}
                                service={"WesternUnion"}
                            />
                        </Box>
                        : ""
                }

                {
                    page === 'receiptReceive' ?
                        <Box
                            sx={{
                                maxHeight: "600px",
                                marginTop: "10px"
                            }}>

                            <InternationalTransferSummary
                                type="receive"
                                transferDetails={formValues}
                                handleReturn={() => setPage("init")}
                                user={selectedUser}
                                handleContinue={() => setPage("init")}
                                isReceipt={true}
                                service={"WesternUnion"}
                            />
                        </Box>
                        : ""
                }

                {
                    page === 'wait' || page === 'init' ?
                        <Box sx={{
                            maxHeight: "600px",
                            marginTop: "10px"
                        }}>
                            <Box
                                className="mt-5 d-flex justify-content-center align-items-center">
                                <CircularProgress
                                    size="10rem" />
                            </Box>
                        </Box>
                        : ''
                }

                {page === 'shortform' ?

                    <Box sx={{
                        maxHeight: "600px",
                        marginTop: "10px"
                    }}>
                        <RegistrationInput
                            label="Amount"
                            type="number"
                            onChange={(e) => editFormValues('amount', e.target.value)}
                            value={formValues.amount}
                            hasError={formErrors.amount} />
                        <RegistrationSelect
                            label="Amount Type"
                            options={amountTypes ?? []}
                            required={true}
                            onChange={(e) => editFormValues('amounttype', e.target.value)}
                            value={formValues.amounttype}
                            hasError={formErrors.amounttype} />
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('landing')}
                            handleButtonTwo={() => validatePage('shortform')}
                            buttonOneText="Return"
                            buttonTwoText="Continue"
                        />
                    </Box>
                    : ''
                }

                {page === 'contact' ?
                    <Box sx={{
                        maxHeight: "600px",
                        marginTop: "10px"
                    }}>
                        {getContactInformation()}

                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('landing')}
                            handleButtonTwo={() => sendToContact()}
                            buttonOneText="Cancel"
                            buttonTwoText="Send To This Contact"
                        />
                    </Box>
                    : ''
                }

                {
                    page === 'track' &&
                    <InternationalTransferTrack
                        transactionStatus={orderStatus}
                        handleReturn={() => setPage('landing')}
                        isCancellable={true}
                        handleCancel={cancelTransaction}
                    />
                }
                {showPin && 
                    <PinPad 
                        show={showPin} 
                        handleConfirm={handlePinConfirm} 
                        onClick={() => setShowPin(false)} 
                    />
                }

                {page === 'cancelform' ?

                    <Box sx={{
                        maxHeight: "600px",
                        marginTop: "10px"
                    }}>
                        <RegistrationSelect
                            label="Reason"
                            options={cancelReasons ?? []}
                            required={true}
                            onChange={(e) => setCancelFormValues({cancelreasoncode: e.target.value, cancelcomments: e.target.label})}
                            value={cancelFormValues.cancelreasoncode} />
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage(prevPage)}
                            handleButtonTwo={() => setShowPin(true)}
                            buttonOneText="Return"
                            buttonTwoText="Cancel Transaction"
                        />
                    </Box>
                    : ''
                }

                {
                    page === 'termsAndConditions' && 
                    <Box sx={{
                        maxHeight: "600px",
                        marginTop: "10px"
                    }}
                    ref={containerRef}>
                        <Typography variant="h6" gutterBottom>
                                Customer must read and agree to the following
                        </Typography>

                        <FormControlLabel
                            control={
                            <Checkbox
                                id="termsAndConditionsCheckbox"
                                name="termsandconditions"
                                value="terms"
                                checked={termsChecked}
                                onChange={(e) => setTermsChecked(e.target.checked)}
                            />
                            }
                            label={
                            <Link
                                href="https://www.westernunion.com/tc/en/legal/terms-conditions.html"
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                            >
                                Terms and Conditions
                            </Link>
                            }
                        />

                        <FormControlLabel
                            control={
                            <Checkbox
                                id="privacycheckbox"
                                name="privacy"
                                value="privacy"
                                checked={privacyChecked}
                                onChange={(e) => setPrivacyChecked(e.target.checked)}
                            />
                            }
                            label={
                            <Link
                                href="https://www.westernunion.com/global/en/privacy-statement.html"
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                            >
                                Privacy Statement
                            </Link>
                            }
                        />

                            <Typography variant="h6" gutterBottom>
                                Protect yourself from fraud
                            </Typography>

                            <Typography paragraph>
                                Only use Western Union to send money to friends and family. Never send money to someone you have not met in person. Scammers sometimes encourage people to transfer money. Do not transfer money to anyone who asks you to send them money:
                            </Typography>

                            {[
                                "For an emergency situation you haven’t confirmed.",
                                "For an online purchase.",
                                "For anti‐virus protection.",
                                "For a deposit or payment on a rental property.",
                                "To claim lottery or prize winnings.",
                                "To pay taxes.",
                                "For a donation to charity.",
                                "For a mystery shopping assignment.",
                                "For a job opportunity.",
                                "For a credit card or loan fee.",
                                "To resolve an immigration matter."
                            ].map((item, index) => (
                                <Typography key={index} sx={{ ml: 2 }}>
                                    • {item}
                                </Typography>
                            ))}

                            <Typography paragraph>
                                If you transfer money, the person you’re sending it to gets the money quickly. After the money is paid, Western Union may not be able to give you a refund, even if you are the victim of fraud, except under limited circumstances. If you believe you are the victim of fraud, call the Western Union Fraud Hotline at 1‑844‑200‑018 or visit {" "}
                                <Link
                                    href="https://www.westernunion.com/tc/en/fraudawareness/fraud-home.html"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://www.westernunion.com/tc/en/fraudawareness/fraud-home.html
                                </Link>
                            </Typography>

                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage(prevPage)}
                            handleButtonTwo={() => validatePage('termsAndConditions')}
                            buttonOneText="Back"
                            buttonTwoText="Continue"
                        />

                        </Box>
                }
            </Box>
            <CustomAlert 
                severity={alert.severity} 
                show={alert.showAlert} 
                header={alert.header} 
                message={alert.message} 
                onClick={(prev) => setAlert({ ...prev, showAlert: false })} 
                autoclose={alert.severity === "error" ? false : true} 
            />
        </Box>
    );
}

export default WesternUnion